import { render, staticRenderFns } from "./UpdateReceipt.vue?vue&type=template&id=42baaf48&scoped=true"
import script from "./UpdateReceipt.vue?vue&type=script&lang=js"
export * from "./UpdateReceipt.vue?vue&type=script&lang=js"
import style0 from "./UpdateReceipt.vue?vue&type=style&index=0&id=42baaf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42baaf48",
  null
  
)

export default component.exports